import { BillingMethod } from 'common/api/e-comm/payment-types';
import { Address } from 'common/api/models/Address';
import { OrganizationType } from 'common/api/store/models/OrganizationType';

export type CountryCode = 'US' | 'CA';

export interface Organization {
    id: string;
    name: string;
    type: OrganizationType;
    address: Address | null;
    countryCode: CountryCode;
    isScriptWareOrg: boolean;
    isP2PInviteEnabled: boolean;
    flipGiveTeamId: string | null;
    isNoBanking: boolean;
    billingMethod: BillingMethod | null;
    approvalDate?: string;
    isActive: boolean | null;
    isApproved: boolean | null;
    isCoordinator?: boolean;
}

export const emptyOrganization: Organization = {
    id: '',
    name: '',
    type: OrganizationType.Miscellaneous,
    address: null,
    countryCode: 'US',
    isScriptWareOrg: false,
    isP2PInviteEnabled: false,
    flipGiveTeamId: null,
    isNoBanking: false,
    billingMethod: null,
    isApproved: true,
    isActive: true,
    isCoordinator: false,
    approvalDate: undefined,
};

// NOTE: For orgnization enrollment version 2
export interface HubspotContactInfo {
    coordinatorEmailAddress: string;
    organizationName: string;
    organizationTypeId: string;
    countryCode: CountryCode;
    coordinatorPhoneNumber?: string;
    coordinatorPhoneNumberExtension?: string;
    originalEnrollmentDate?: string;
}

export interface HubspotFamilyContactInfo {
    emailAddress: string;
    firstName?: string;
    lastName?: string;
    originalEnrollmentDate?: string;
    participantEnrollmentStage: string;
}

export interface UploadCheckImageState {
    file: File | null;
    error: string | null;
}
